"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_toastify_1 = require("react-toastify");
var AlertType;
(function (AlertType) {
    AlertType["INFO"] = "info";
    AlertType["SUCCESS"] = "success";
    AlertType["DANGER"] = "error";
})(AlertType = exports.AlertType || (exports.AlertType = {}));
function flash(msg, type, callback) {
    if (type === void 0) { type = AlertType.INFO; }
    if (callback === void 0) { callback = function () { }; }
    react_toastify_1.toast[type](msg, {
        position: 'top-center',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: false,
        progress: undefined,
        onClose: callback,
    });
}
exports.flash = flash;
//# sourceMappingURL=alerts.js.map